import { render, staticRenderFns } from "./UsersAddUser.vue?vue&type=template&id=a0525476&scoped=true&"
import script from "./UsersAddUser.vue?vue&type=script&lang=js&"
export * from "./UsersAddUser.vue?vue&type=script&lang=js&"
import style0 from "./UsersAddUser.vue?vue&type=style&index=0&id=a0525476&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0525476",
  null
  
)

export default component.exports